<template>
  <svg
    id="light"
    enable-background="new 0 0 24 24"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
    :fill="color"
  >
    <path
      d="m22.5 21h-21c-.827 0-1.5-.673-1.5-1.5v-14c0-.827.673-1.5 1.5-1.5h21c.827 0 1.5.673 1.5 1.5v14c0 .827-.673 1.5-1.5 1.5zm-21-16c-.276 0-.5.224-.5.5v14c0 .276.224.5.5.5h21c.276 0 .5-.224.5-.5v-14c0-.276-.224-.5-.5-.5z"
    />
    <path
      d="m15.5 24h-7c-.202 0-.385-.122-.462-.309-.078-.187-.035-.402.108-.545 1.316-1.316 1.333-2.59 1.333-2.644.001-.275.225-.502.501-.502h4.02c.275 0 .499.222.5.497.001.063.04 1.336 1.354 2.649.143.143.186.358.108.545-.077.187-.26.309-.462.309zm-5.929-1h4.857c-.56-.801-.782-1.537-.87-2h-3.13c-.085.465-.301 1.2-.857 2zm4.929-2.5h.01z"
    />
    <path d="m23.5 18h-23c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h23c.276 0 .5.224.5.5s-.224.5-.5.5z" />
    <path
      d="m7.5 15c-.128 0-.256-.049-.354-.146-.195-.195-.195-.512 0-.707l3.5-3.5c.152-.153.385-.191.577-.094l1.678.839 3.245-3.245c.195-.195.512-.195.707 0s.195.512 0 .707l-3.5 3.5c-.153.152-.385.189-.577.094l-1.678-.839-3.245 3.245c-.097.097-.225.146-.353.146z"
    />
    <path
      d="m16.5 12c-.276 0-.5-.224-.5-.5v-2.5h-2.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h3c.276 0 .5.224.5.5v3c0 .276-.224.5-.5.5z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "25"
    },
    height: {
      type: String,
      default: "25"
    },
    color: {
      type: String,
      default: "#fff"
    }
  }
};
</script>

<style lang="scss" scoped>
svg {
  text-align: center;
  vertical-align: middle;
}
</style>